import {Directive, Inject, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {MX_PERMISSION_TOKEN, MxPermissionService} from '../../services/mx-permission.service';

@Directive({
    selector: '[mxRestrict]',
    standalone: false,
})
export class RestrictDirective {
    constructor(@Inject(MX_PERMISSION_TOKEN) public permissionService: MxPermissionService,
                private content: TemplateRef<any>,
                private viewContainer: ViewContainerRef) {
    }

    @Input('mxRestrict')
    private set access(access: string) {
        this.viewContainer.clear();
        if (this.permissionService.hasPermission(access)) {
            this.viewContainer.createEmbeddedView(this.content, this);
        }
    }
}
